import React from 'react';
import { ServicesContext } from '~/services';
import { ReminderFeed } from '~/components/Reminders';

interface FocGapRemindersProps {
    focGapId: number;
    patientId: number;
    addReminderOpen?: boolean;
}

export function FocGapReminders({
    focGapId,
    patientId,
    addReminderOpen = false,
}: FocGapRemindersProps) {
    const servicesContext = React.useContext(ServicesContext);
    async function performAdd(description: string, dueDate: string) {
        await servicesContext.patient.updateFocGap(focGapId, patientId, {
            tasks: [{ description, due_at: dueDate }],
        });
    }
    return (
        <ReminderFeed
            performAdd={performAdd}
            loadEntity={`foc_gap.id=${focGapId}`}
            addReminderOpen={addReminderOpen}
            isPCMView
        />
    );
}
